




















import { Vue, Component } from 'vue-property-decorator'
import ContextWrapper from '@/orrm/wrapper/context'
import { context } from '@/store/modules'
import ScrollList from '@/components/ScrollList.vue'
import intersectionWith from 'lodash/intersectionWith'
import LayerWrapper from '@/orrm/wrapper/layer'

@Component({
  components: { ScrollList }
})
export default class ContextList extends Vue {
  get contexts (): ContextWrapper[] {
    return context.contexts
  }

  get activeContextId () {
    return context.activeContext ? context.activeContext.model.uuid : null
  }

  selectContext (item: ContextWrapper) {
    context.setActiveContext(item)
    setTimeout(async () => { // Timeout à but esthétique (animation)
      await this.$router.push({ name: 'Home' })
    }, 300)
  }

  resetContext (item: ContextWrapper) {
    context.resetContext(item)
  }

  isUnchanged (item: ContextWrapper): boolean {
    const originalContext = context.originalContexts.find((context: ContextWrapper) => context.model.uuid === item.model.uuid)

    if (originalContext) {
      const intersection = intersectionWith(originalContext.layers, item.layers, (a: LayerWrapper, b: LayerWrapper) => a.model.uuid === b.model.uuid)
      return intersection.length === originalContext.layers.length
    }
    return false
  }
}
